// ---- Prevent Dawn from auto-opening the drawer unless we allow it ----
window.__UPS_SEE_SUPPRESS_DRAWER__ = false;

// Patch drawer.open once it exists
(function patchDrawerOpenEarly() {
  function tryPatch() {
    const drawer = document.querySelector("cart-drawer");
    if (!drawer || drawer.__upsellOpenPatched) return false;

    const _open = drawer.open;
    drawer.open = function (triggeredBy) {
      if (window.__UPS_SEE_SUPPRESS_DRAWER__) {
        return; // do not open
      }
      return _open.apply(this, arguments);
    };
    drawer.__upsellOpenPatched = true;
    return true;
  }

  if (!tryPatch()) {
    // if drawer not in DOM yet, watch for it
    const mo = new MutationObserver(() => tryPatch() && mo.disconnect());
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }
})();

async function refreshCartDrawer(silent = true) {
  const cart = await (await fetch("/cart.js")).json();
  const res = await fetch(
    `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
  );
  const sections = await res.json();

  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const parsedState = {
      id: cart.token || null,
      item_count: cart.item_count, // ✅ add this
      sections,
    };

    drawer.renderContents(parsedState, { silent });
  }
}

async function removeUpsellsAlreadyInCart(modal) {
  const cart = await (await fetch("/cart.js")).json();

  modal.querySelectorAll(".upsell-item").forEach((item) => {
    const productId = parseInt(item.dataset.product, 10);
    const variantId = parseInt(item.dataset.variant, 10);
    const tags = (item.dataset.tags || "").split(",");

    const isStandalone = tags.includes("standalone-upsell");
    const isSinglePerParent = tags.includes("single-parent-upsell"); // 👈 add this tag in Shopify for High-Res Digital Copy

    if (isStandalone) {
      const exists = cart.items.some((c) => c.product_id === productId);
      if (exists) {
        item.remove();
      }
    }

    if (isSinglePerParent) {
      const parentKey = document.querySelector("product-form form")?.dataset.parentKey;
      const exists = cart.items.some(
        (c) => c.variant_id === variantId && c.properties?._parent === parentKey
      );
      if (exists) {
        item.remove();
      }
    }
  });
}




document.addEventListener("DOMContentLoaded", () => {

  const modal = document.getElementById("UpsellModal");
  const continueBtn = document.getElementById("UpsellContinue");
  const productForm = document.querySelector("product-form form");
  if (!modal || !productForm) return;

  // 1) Intercept submit in CAPTURE phase so Dawn's handler never runs
  productForm.addEventListener(
    "submit",
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      // block drawer auto-open during our flow
      window.__UPS_SEE_SUPPRESS_DRAWER__ = true;

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(productForm),
      })
        .then((r) => r.json())
        .then((data) => {

           // save the parent's line item key (unique per cart line)
    const parentKey = data.key;

    // store it somewhere accessible, e.g. on the form element
    productForm.dataset.parentKey = parentKey;

          // 🔄 Reset upsell UI state on every modal open
          modal.querySelectorAll(".upsell-item").forEach((i) => {
            i.classList.remove("added");
            const btn = i.querySelector(".upsell-toggle");
            if (btn) btn.textContent = "ADD";
          });

          modal.classList.remove("hidden"); // show upsell

            // ✅ Hide standalone upsells already in cart
  removeUpsellsAlreadyInCart(modal);

  // ✅ If no upsell items left, skip modal and just open drawer
if (!modal.querySelector(".upsell-item")) {
  modal.classList.add("hidden");
  window.__UPS_SEE_SUPPRESS_DRAWER__ = false;

  // open the cart drawer immediately
  const drawer = document.querySelector("cart-drawer");
  drawer?.open();
  return;
}

modal.classList.remove("hidden"); // show upsell if something remains
  
          // ✅ Refresh drawer in background so it’s ready
          refreshCartDrawer(true);
        })
        .catch((err) => console.error("🔴 [Upsell] Add error:", err));
    },
    true
  ); // << capture=true

  // 2) Upsell add/remove (unchanged logic, keep your parentId from the form)
  const formVariantInput = productForm.querySelector('[name="id"]');
  modal.querySelectorAll(".upsell-toggle").forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      const item = e.currentTarget.closest(".upsell-item");
 const parentKey = productForm.dataset.parentKey; // unique key for parent
      const variantId = btn.dataset.variant;
  const tags = (item.dataset.tags || "").split(",");
  const isStandalone = tags.includes("standalone-upsell");

      if (item.classList.contains("added")) {
        const cart = await (await fetch("/cart.js")).json();
        const lineItem = cart.items.find(
          (i) => i.variant_id == variantId && i.properties?._parent == parentKey
        );
        if (lineItem) {
          await fetch("/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: lineItem.key, quantity: 0 }),
          });

          // ✅ Refresh drawer silently
          refreshCartDrawer(true);
        }
        item.classList.remove("added");
        btn.textContent = "ADD";
      } else {
       
         const payload = {
            items: [
              isStandalone
                ? { id: variantId, quantity: 1 } // ✅ no _parent
                : { id: variantId, quantity: 1, properties: { _parent: parentKey } },
            ],
          };

          await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });




        item.classList.add("added");
        btn.textContent = "REMOVE";
        // ✅ Refresh drawer silently
        refreshCartDrawer(true);
      }
    });
  });

  // 3) Close modal silently OR open drawer on Continue
modal.querySelector(".upsell-close")?.addEventListener("click", () => {
  modal.classList.add("hidden");
  window.__UPS_SEE_SUPPRESS_DRAWER__ = false; // 👈 reset so drawer can open again
});


  function safeOpenCartDrawer() {
    const drawer = document.querySelector("cart-drawer");
    const container = drawer?.querySelector(".drawer__inner");

    if (!drawer || !container) {
      console.warn("Cart drawer not ready, retrying...");
      setTimeout(safeOpenCartDrawer, 100); // retry in 100ms
      return;
    }
    drawer.open();
  }

  continueBtn?.addEventListener("click", async () => {
    modal.classList.add("hidden");
    window.__UPS_SEE_SUPPRESS_DRAWER__ = false;

    try {

      const cart = await (await fetch("/cart.js")).json();

      const res = await fetch(
        `${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`
      );
      const sections = await res.json();

      const drawer = document.querySelector("cart-drawer");
      if (drawer) {
        const parsedState = {
          id: cart.token || null,
          item_count: cart.item_count, // 👈 add this like in refreshCartDrawer
          sections,
        };

        drawer.renderContents(parsedState, { silent: false }); // Dawn should open
      } else {
        console.warn("🔴 No cart-drawer element in DOM");
      }
    } catch (err) {
      console.error("🔴 Failed to refresh cart drawer:", err);
    }
  });
});
